const Form078SC = {
    stepName: {
        information: "基本资料",
        partA: "甲部\n原任合约教职员及代职人员资料",
        partB: "乙部\n申领金额及\n补充资料",
        partC: "丙部\n认证",
        confirm: "确认",
    },
    notes: {
        notesTitle: "声明",
        importantNote1:
            "[i.e. 请提交电子表格或纸质表格，请注意，如果提交了重複的申请，处理过程可能会受影响。",
        importantNote2:
            "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向有关高级学校发展主任提出。]",
        importantNote3:
            "此表格只适用于聘用代职人员替代以教育局现金津贴聘请的合约教职员放取14个星期有薪产假。",
        note1: "如原任合约教职员<u>未符合</u>《雇佣条例》（第57章）的规定放取<u>有薪</u>产假，即使学校有聘任代职人员替代其职务，亦<u>不可</u>向教育局申领「额外代职人员津贴」。",
        note2: "额外薪金指聘任代职人员以替代休假合约教职员放取<u>额外四个星期法定有薪产假</u>的代职人员薪金开支（即最多28日）。",
        note3: "发还金额的<u>上限</u>以原任合约教职员于正常工作日的薪酬厘定（即并非其产假薪酬）。如原任合约教职员为兼任人员，则须填写<u>已反映</u>其兼任职务的月薪。如原任合约教职员额外四个星期产假横跨两个历月，而两个历月的月薪并不相同，则须分别列出该两个历月的月薪资料。",
        note3a: "发还金额的<u>上限</u>以原任合约教职员于正常工作日的薪酬厘定（即并非其产假薪酬）。如原任合约教职员为兼任人员，则须填写<u>已反映</u>其兼任职务的月薪。如原任合约教职员额外四个星期产假横跨两个历月，而两个历月的月薪并不相同，则须分别列出该两个历月的月薪资料。此外，学校亦须填写原任合约教职员于额外四个星期产假期间的<u>每日平均工资</u>（以原任合约教职员的月薪金额×12个月/365日计算）。",
        note4: "原任合约教职员的薪金来源必须为<u>教育局提供的现金津贴</u>。",
        note5: "如原任合约教职员在放取额外四星期有薪产假期间，学校曾聘任一名或以上的代职人员，学校须<u>分别</u>列出各代职人员的姓名及聘用详情。",
        note6: "聘请代职人员的全职工作比例<u>不可超逾</u>原任合约教职员于放取额外四星期（即28日）有薪产假期间，属教育局现金津贴支薪的全职工作比例[即表格({{field}})栏内填报的全职工作比例]。",
        note7: "代职人员的月薪金额<u>不得高于</u>原任合约教职员的月薪金额[即表格(b)栏内填报的「月薪」金额]。如原任合约教职员额外四个星期产假横跨两个历月，而该两个历月的月薪金额并不相同，相关代职人员的月薪金额亦<u>不可高于</u>原任合约教职员在该两个历月的<u>相应</u>薪酬。如代职人员为兼任人员，则须填写<u>已反映</u>其兼任职务的月薪，并于表格(c)栏填写其全职工作比例。",
        note7a: "代职人员的日薪率<u>不得高于</u>原任合约教职员的每日平均工资[即表格(h)栏内填报的「经换算的每日平均工资」金额]。如原任合约教职员额外四个星期产假横跨两个历月，而该两个历月的月薪及经换算的每日平均工资并不相同，代职人员的日薪率亦<u>不可高于</u>原任合约教职员在该两个历月的<u>相应</u>每日平均工资。如代职人员为兼任人员，则须填写<u>已反映</u>其兼任职务的日薪，并于表格(i)栏填写其全职工作比例。",
        note8: "代职历日日数指由起始日至完结日期间的历日数目（首尾两天包括在内），此栏的代职历日总日数<u>不可超逾28日</u>。如该代职人员在受雇期间曾放取无薪假期，<u>代职历日日数须扣除无薪假期的日数</u>，学校亦须于乙部(i)提供详细资料。",
        note8a: "实际工作日数<u>不应</u>包括公众假期、由学校自行订定的假期或教职员无需执行职务的任何日期。实际工作总日数亦<u>不可超逾28日</u>。",
        note9: "薪金应根据代职历日日数按比例计算[以代职人员的每日平均工资（代职人员的月薪金额×12个月/365日）×代职历日日数]。",
        note9a: "薪金应根据代职人员的日薪率×代职人员的实际工作日数计算。",
        note10: `强积金计划供款津贴的计算方法为有关入息的5% 供款，并受限于<u>按28日比例计算</u>的最高有关入息水平的供款（1,381元 = 现时最高供款每月1,500元×12个月/365日×28日）。如学校无需向该代职人员的强积金计划供款，请在此栏填写"0"。`,
        termsTips1: "申请人应仔细阅读并同意",
        termsTips2: "隐私数据的注意事项",
        agreeTips: "我已阅读、理解并同意上述条款和条件。",
    },
    button: {
        addSupplyStaff: "新增代职人员",
        removeSupplyStaff: "移除代职人员",
    },
    serial: {
        tips: {
            num1: "(ⅰ)",
            num2: "(ⅱ)",
            num3: "(ⅲ)",
            num4: "(ⅳ)",
            num5: "(ⅴ)",
            num6: "(ⅵ)",
            num7: "(ⅶ)",
            num8: "(ⅷ)",
        },
    },
    label: {
        basicOption: {
            note: "注",
            contactPerson: "学校联络人",
        },
        informationTitle: "学校资料",
        schoolName: "学校名称",
        schoolCode: "学校代码",
        month: "月份",
        year: "年份",
        contactPerson: "学校联络人（以便教育局处理本表格时作查询之用）",
        telNo: "电话号码",
        ssdo: "高级学校发展主任",
        pleaseSpecify: "请注明",
        partAOption: {
            tips1: "本校欲申领上述津贴以发还因原任合约教职员放取延长有薪产假至14个星期",
            tips2: "，而聘任合资格代职人员所支付的额外薪金",
            tips3: "， 详情如下：",
            title: "<b>甲部 原任合约教职员及代职人员资料</b>",
            titleTips:
                "（请使用下列表格I及II分别填写以月薪及日薪形式聘请的代职人员资料）",
            title1: "I. 以月薪形式聘请的代职人员",
            monthTips: "放取14个星期有薪产假的<b>原任合约教职员</b>资料",
            name: "姓名",
            teachingStaffLabel: "是否为教学人员",
            teachingStaff: {
                Yes: "教学人员",
                No: "非教学人员",
            },
            leavePeriod: "休假日期",
            firstTenWeekLabel: "首10个星期",
            additionalWeekLabel: "额外四个星期 ({{serial}})",
            additionalWeek: "额外四个星期产假的薪金资料",
            additionalWeekTips:
                "[只计算由教育局现金津贴所支付的薪金] ({{serial}})",
            monthlySalary: "月薪",
            amountUnit: "（元）",
            month: "月",
            rank: "职级",
            percentage: "占全职工作比例",
            fundingSource: "薪金来源",
            fundingSourceFile:
                "原任合约教职员放取14个星期有薪产假期间的薪金证明",
            monthlyPaidTips:
                "在原任合约教职员放取额外四个星期有薪产假 [即表格(a)栏]期间所有以<b>月薪聘请的代职人员</b>资料",
            dailyRatedTips:
                "在原任合约教职员放取额外四个星期有薪产假 [即表格(g)栏]期间所有以<b>日薪聘请的代职人员</b>资料",
            supplyStaffName: "代职人员姓名",
            substitutionPeriodTitle:
                "代职日期 <i>[不得超逾表格({{serial}})栏所示日期]</i>",
            substitutionPeriod: "代职日期",
            from: "由",
            to: "至",
            workingDays: "代职历日日数",
            salaryAmount: "薪金",
            salaryAmountFile:
                "所有代职人员（包括首10个星期及额外四个星期）的薪酬收据",
            mpfSubsidy: "强积金计划供款津贴",
            mpfSubsidyFile: "所有代职人员的强积金计划供款的证明资料（如适用）",
            mpfSubsidyFileTips:
                "[如代职期少于60个历日，但代职人员须向强积金计划供款，请提供理由及相关证明]",
            grantAmount: "津贴金额 (f) = (d) + (e)",
            grantAmountDaily: "津贴金额 (l) = (j) + (k)",
            grantAmountMsg: "津贴金额",
            dayAmount: "[ 经换算的每日平均工资为",
            dayAmountR: "]",
            dailyRate: "日薪率",
            actualWorkingDays: "实际工作日数",
            totalDays: "总日数",
            totalAmount: "总额",
            title2: "II. 以日薪形式聘请的代职人员",
        },
        partBOption: {
            title: "<b>乙部 申领金额及补充资料</b>",
            stepNote1: "于原任合约教职员放取14个星期有薪产假期间，",
            stepNoteChild: {
                note1: "已连续14个星期聘任代职人员，以履行原任合约教职员的职务。",
                note2: "曾聘任代职人员，以履行原任合约教职员的职务，但<u>代职时段少于14个星期</u>，原因是（可选多于一项）：",
            },
            childNoteOption: {
                childNoteA1: "教职员放取之有薪产假有部分时段与主要学校假期（",
                childNoteA2: "学校在某时段未能聘请合适的代职人员",
                childNoteA3: "学校未有足够时间招聘代职人员",
                childNoteA4:
                    "学校需要在该段产假期间聘请多于一名代职人员，而他们的任职期未能完全连接",
                childNoteA5: "月薪代职人员曾于受雇期间放取无薪假期，详情为：",
                childNoteA6: "其他原因",
            },
            childNoteEndA1: "）重迭，故此，学校无需在该段产假期间聘请代职人员",
            stepNote2Start:
                "现以<u>实报实销形式</u>向教育局申领「额外代职人员津贴」共",
            stepNote2End:
                "元[原则上为表格(f)及(l)栏的总额]，以发还因原任合约教职员放取额外四个星期法定有薪产假的代职人员薪金开支（即最多28日）。谨此附上<u>经校监签署核证</u>的下列文件副本，以供查考：",
            childNoteBOption: {
                childNoteB1: "原任合约教职员的薪金证明；",
                childNoteB2:
                    "所有代职人员（包括首10个星期及额外四个星期）的薪酬收据；及",
                childNoteB3:
                    "所有代职人员的强积金计划供款的证明资料（如适用）[如代职期少于60个历日，但代职人员须向强积金计划供款，请提供理由及相关证明]。",
            },
            left: "（",
            right: "）",
            detailMsg: "详情",
            specifyMsg: "原因",
            leaveType: {
                ch: "圣诞节假期",
                cnyh: "农历新年假期",
                eh: "复活节假期",
                sv: "暑假",
            },
        },
        partCOption: {
            title: "丙部 认证",
            noteTitle: "本人证实—",
            surplusTeachers: "过剩教师",
            teacherNumber: "过剩教师人数",
            claimDate: "申请日期",
            certifyNote1:
                "已审阅相关证明文件（包括注册医生、注册助产士或注册中医签发证实怀孕的有效证明书、注明预产期或实际分娩日期（按适当情况而定）的医生证明书等），并按照《雇佣条例》（第57章）及教育局相关规定批准上述以现金津贴聘请的合约教职员放取延长有薪产假至14个星期；",
            certifyNote2:
                "已要求代职人员进行性罪行定罪纪录查核，并已致电自动电话查询系统收听代职人员性罪行定罪纪录查核的结果；",
            certifyNote3:
                "所聘用的代职人员如属教师，他／她必须是检定教师，或已具备可申请成为检定教员或准用教员的所需资历，并在上任前提交教师注册申请。学校亦已仔细查阅教师的身份证明文件和教师注册证的正本及／或查询其教师注册身份和相关资料；所聘用的代职人员如属非教学的专责人员，他／她亦须具备相关的资格；",
            certifyNote4: "本校",
            certifyNoteNo: "并",
            certifyNoteMiddle: "过剩常额教师",
            certifyNoteYes: "名",
            certifyNote4Start:
                "，而在聘请代课教师替代原任合约教师放取额外四个星期法定有薪产假期间，过剩常额教师数目<u>已经抵销</u>[即在同一时间内，休假連续三日或以上的教师数目（包括常额教师及以教育局「现金津贴」聘请的合约教师的数目）超逾过剩常额教师数目。如需要，请注明有关详情：",
            certifyNote4Char: "]。",
            certifyNote4End:
                "如学校的过剩常额教师数目未被抵销，因额外四个星期有薪假期而衍生的代职人员薪金开支将不会获得发还；",
            certifyNote5:
                "上述各部分提供的资料正确无误及完整（已包括原任合约教职员放取额外四个星期产假期间的<span style='border-bottom: 3px double #000;'>所有</span>代职人员的聘用资料），本校就此个案的申请已完成，亦明白如上述资料及相关证明文件不齐全，教育局不会处理本表格；",
            certifyNote6:
                "学校已先行向代职人员支付薪酬及其他法定责任的相关开支；",
            certifyNote7:
                "如发放的津贴额多于本校应得，本校会把多收的津贴退还政府；及",
            certifyNote8:
                "已支付予该原任合约教职员的额外四个星期法定产假薪酬及额外代职人员津贴不曾／将不会获其他政府拨款支付／补贴。",
            applicationDate: "申请日期",
            supervisorName: "校监姓名",
        },
        slash: "／",
        smcImc: "校董会／法团校董会",
    },
    select: {
        monthOption: [
            { key: "", value: "请选择" },
            { key: "01", value: "01" },
            { key: "02", value: "02" },
            { key: "03", value: "03" },
            { key: "04", value: "04" },
            { key: "05", value: "05" },
            { key: "06", value: "06" },
            { key: "07", value: "07" },
            { key: "08", value: "08" },
            { key: "09", value: "09" },
            { key: "10", value: "10" },
            { key: "11", value: "11" },
            { key: "12", value: "12" },
        ],
        ssdoOption: {
            CWD: "中西区",
            SD: "南区",
            WCD: "湾仔区",
            ID: "离岛区",
            HKED: "东区",
            KCD: "九龙城区",
            SSPD: "深水埗区",
            SKD: "西贡区",
            KTD: "观塘区",
            WTSD: "黄大仙区",
            YTMKD: "油尖旺区",
            TPD: "大埔区",
            ND: "北区",
            STD: "沙田区",
            KCTYD: "葵青区",
            TWD: "荃湾区",
            TMD: "屯门区",
            YLD: "元朗区",
        },
        supplyStaffOption: {
            PartAI: "I. 以月薪形式聘请的代职人员",
            PartAII: "II. 以日薪形式聘请的代职人员",
        },
        schoolIncorporatedOption: {
            smc: "校董会",
            imc: "法团校董会",
        },
        surplusTeachersOption: {
            Yes: "有",
            No: "没有",
        },
    },
    errorMsg: {
        required: "此项必须填写",
        twoRequired: "前两项必须填写",
        maxOneDecimal: "此项必须为小数后最多1位",
        numberUnit: "该字段必须最小单位为0.5",
        validPrice: "请输入一个有效的价格",
        numberMax: "此项必须为最多{{number}}位",
        telMax: "电话号码必须为最多12位数",
        monthDiffError: "请选择不同的月份",
        monthRangeError: "请选择休假日期「额外四个星期」范围内的月份",
        substitutionPeriodError: "此项必须在({{fild}})栏所示日期范围之内",
        monthlySalaryError: "此项不得高于(b)栏内填报的月薪金额",
        percentageError: "此项不得高于({{fild}})栏内填报的占全职工作比例",
        dailyRateError: "此项不得高于(h)栏「经换算的每日平均工资」金额",
    },
};
export default Form078SC;
